import React, { useEffect } from 'react'
import useAxios from 'axios-hooks'
import { useQueryParams, StringParam } from 'use-query-params'
import ScanSettingsList from 'views/ScanSettings/ScanSettingsView/components/ScanSettingsList'
import { useProjects } from 'context/project-context'
import { getAuthHeader } from 'utils/auth'
import NoScanSettings from 'views/ScanSettings/ScanSettingsView/components/NoScanSettings'
import { ErrorBoundary, ignoreTimeoutExceptions } from 'components'

function ScanSettingsView({ navigate }) {
  const [query, setQuery] = useQueryParams({
    type: StringParam,
    owner: StringParam
  })

  const { project } = useProjects()

  const onFilterChange = (val, e) => setQuery({ [e.props.name]: val })

  const [{ data, loading, error }, getScanSettingsList] = useAxios(
    {
      url: `${project.name}/scan-settings/list`,
      method: 'POST',
      headers: getAuthHeader()
    },
    { manual: true }
  )

  useEffect(() => {
    getScanSettingsList({ data: { ...query } })
    let interval = setInterval(() => {
      getScanSettingsList({ data: { ...query }, timeout: 30000 }).catch(() => {});
    },30000)
    return () => {
      if (interval) {
        clearInterval(interval)
      }
    }
  }, [query])

  if ((!loading && !data) || (!loading && data && !data.length && !query.type && !query.owner && !error))
    return <NoScanSettings navigate={navigate} />


  let errorsMessage = ignoreTimeoutExceptions(error);

  return (
    <ErrorBoundary>
      <ScanSettingsList
        data={data}
        loading={loading}
        error={errorsMessage}
        onFilterChange={onFilterChange}
        navigate={navigate}
        getScanSettingsList={getScanSettingsList}
      />
    </ErrorBoundary>
  )
}

export default ScanSettingsView
